<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        version="1.1"
        :height="height"
        :width="width"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 203.282"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <!-- <path class="fil0 str1" d="M80 127l0 28c-2,28 -57,32 -61,0l0 -25" /> -->
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M43.63 169.661c-1.241,9.147 -3,18.277 -5.279,27.389 -12.573,1.129 -25.967,1.082 -23.25,-27.043 10.253,2.526 19.763,2.411 28.529,-0.346z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M43.63 169.661c-8.766,2.757 -18.276,2.872 -28.529,0.346 0.467,-4.834 1.409,-10.497 2.914,-17.126 0.684,-3.016 1.59,-5.942 2.684,-8.745 1.063,-2.727 2.304,-5.337 3.688,-7.798 7.308,4.469 14.423,7.173 21.345,8.111 -0.264,8.419 -0.965,16.823 -2.102,25.212z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M62.706 143.095c-0.402,8.567 -0.834,16.887 -1.296,24.96 -0.592,10.331 -1.233,20.258 -1.925,29.781 -3.71,-0.437 -7.68,-0.999 -11.836,-1.433 -2.849,-0.016 -6.046,0.355 -9.298,0.647 2.279,-9.112 4.038,-18.242 5.279,-27.389 1.137,-8.389 1.838,-16.793 2.102,-25.212 5.793,0.785 11.451,0.333 16.974,-1.354z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M62.706 143.095c-5.523,1.687 -11.181,2.139 -16.974,1.354 -6.922,-0.938 -14.037,-3.642 -21.345,-8.111 7.271,-12.918 18.523,-21.738 29.085,-21.922 9.498,-0.166 20.273,5.639 26.848,18.72 -5.711,4.795 -11.582,8.115 -17.614,9.959z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M61.41 168.055c0.462,-8.073 0.894,-16.393 1.296,-24.96 6.032,-1.844 11.903,-5.164 17.614,-9.959 0.858,1.71 1.646,3.544 2.349,5.504 2.213,6.168 3.595,13.594 3.766,22.369 0.338,3.076 0.568,5.909 0.696,8.519 -8.903,0.728 -17.477,0.236 -25.721,-1.473z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M61.41 168.055c8.244,1.709 16.818,2.201 25.721,1.473 1.461,29.637 -10.246,30.354 -27.646,28.308 0.692,-9.523 1.333,-19.45 1.925,-29.781z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M18.015 152.881c4.848,-21.361 20.815,-38.209 35.457,-38.465 14.643,-0.256 32.322,13.681 32.963,46.593 4.992,45.457 -13.427,38.043 -38.786,35.394 -15.758,-0.09 -42.157,11.655 -29.634,-43.522zm64.654 -14.241c-6.403,-32.342 -11.448,-69.747 -15.136,-112.213m-12.801 -4.992c-5.745,7.684 -11.376,18.924 -13.185,34.305 -2.868,24.378 -8.737,53.9 -20.848,88.396m34.033 -122.701c6.72,-9.384 10.987,-7.72 12.801,4.992"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="65.788"
            cy="105.711"
            r="9.984"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="65.967"
            cy="13.734"
            r="9.984"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
